import InvoiceApi from './Invoice'
import CustomerApi from './Customer'
import CustomElementContentApi from './CustomElementContent'
import OrganizationSettingApi from './OrganizationSetting'

class PromiseHandler {
  constructor (customerId, ocr, preview) {
    this.customerId = customerId
    this.ocr = ocr
    this.preview = preview
  }

  async execute () {
    return Promise.all([
      this.getCustomerPromise().then(res => res.json()),
      this.getInvoicePromise().then(res => res.json()),
      this.getCustomElementContentPromise().then(res => res.json()),
      this.getOrganizationSettingPromise().then(res => res.json())
    ]).then((res) => {
      return res
    }).catch((error) => {
      console.error(this.getErrorMessage(error))
      throw error
    })
  }

  getCustomerPromise () {
    const customerApi = new CustomerApi()
    return customerApi.getPromise(this.customerId)
  }

  getInvoicePromise () {
    const invoiceApi = new InvoiceApi()
    return invoiceApi.getPromise(this.ocr)
  }

  getCustomElementContentPromise () {
    const customElementContentApi = new CustomElementContentApi()
    return customElementContentApi.getPromise(this.ocr, this.preview)
  }

  getOrganizationSettingPromise () {
    const organizationSettingApi = new OrganizationSettingApi()
    return organizationSettingApi.getPromise(this.customerId)
  }

  getErrorMessage (error) {
    return `API is not reachable. Error Message: ${error}`
  }
}

export default PromiseHandler
